<template>
  <div v-if="live" class="home-live-slide py-4 py-md-0">
    <router-link
      class="text-light"
      :to="{
        name: 'live',
        params: { ...live }
      }"
    >
      <img :src="live.picture" class="img-fluid" />
      <h6 class="mt-2">{{ live.name }}</h6>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    live: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>

<style lang="scss" scoped>
.home-live-slide {
  img {
    width: 100%;
    border-radius: 3px;
  }

  a {
    font-size: 14px;
  }

  h6 {
    font-size: 14px;
  }
}
</style>
